import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { INFRASTRUCTURE_PIPELINE_VECTOR } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import DataActions from '../redux/dataRedux'

const id = 'InfrastructurePipelineVector'
const sourceLayer = 'InfrastructurePipeline'
const authId = 'Infrastructure'

export class InfrastructurePipelineVector extends Component {
  componentDidMount () {
    const { map } = this.context
    map.on('moveend', this.handleClick)
  }

  componentWillUnmount () {
    const { map } = this.context
    map.off('moveend', this.handleClick)
  }

  handleClick = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    if (!layerRendered) {
      return
    }
    const features = map.queryRenderedFeatures(undefined, {
      layers: ['InfrastructurePipelineVector']
    })
    const data = features.map(feature => feature.properties)

    actions.dataUpdated(data)
  }

  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions } = this.props
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const {
      idToken,
      layerRendered,
      time,
      uuidsSelected = [],
      paint
    } = this.props
    const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''
    const vectorSource = {
      type: 'vector',
      tiles: [INFRASTRUCTURE_PIPELINE_VECTOR({ idToken, timeIso })],
      tileSize: 512
    }

    const layout = {
      'line-join': 'round',
      'line-cap': 'round'
    }

    if (!visible) {
      return null
    }

    return (
      <div>
        <Source id={id} tileJsonSource={vectorSource} />
        <Layer
          type='line'
          id={id}
          sourceId={id}
          sourceLayer={sourceLayer}
          paint={paint}
          layout={layout}
        />
        <Layer
          key={`${id}Selected`}
          type='line'
          sourceId={id}
          sourceLayer={sourceLayer}
          layout={{}}
          paint={{
            'line-opacity': 1,
            'line-color': 'red',
            'line-width': 10
          }}
          filter={['in', 'ogc_fid'].concat(uuidsSelected)}
        />,
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(state, id, authId),
      paint: getPaint(state, id),
      time: state.layer.times.InfrastructurePipelineVector || undefined
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: json =>
        dispatch(DataActions.dataFulfilled(json, 'InfrastructurePipeline'))
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(
  InfrastructurePipelineVector
)



// WEBPACK FOOTER //
// ./src/layers/InfrastructurePipelineVector.js